var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{class:[
    [_vm.$style.imageContainer],
    ( _obj = {}, _obj[_vm.$style.hasMobileImage] = _vm.hasMobileImage, _obj ) ],attrs:{"data-luko-tracking":"ArticleImage"}},[_c('PImage',{class:_vm.$style.desktopImage,attrs:{"image-object":_vm.primary.image}}),_vm._v(" "),(_vm.hasMobileImage)?_c('PImage',{class:_vm.$style.mobileImage,attrs:{"image-object":_vm.primary.mobile_image}}):_vm._e(),_vm._v(" "),_c('figcaption',[_c('RichText',{attrs:{"text-params":_vm.primary.caption}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }